import React, { Component } from "react";
import { DatePicker, Select, Space } from "antd";
import moment from "moment";
import { apiJourney } from "../../../../api/api-journey";

const STATUS_DATA = {
  1: "Đang chờ điều xe",
  2: "Đã điều xe",
  3: "Đang diễn ra",
  4: "Đã hoàn thành",
  5: "Đã hủy",
  6: "Đã cho mượn xe",
  7: "Đang cho mượn tài",
  8: "Đang cho mượn xe và tài",
};

export class ShortInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from: moment().startOf("month"),
      end: moment(),
      name: "",
      dataSuggest: [],
    };
  }

  getStatus = (contract) => {
    if (
      contract.driver_is_transferred_another === false &&
      contract.vehicle_is_transferred_another === false
    ) {
      return contract.status;
    } else if (
      contract.driver_is_transferred_another === true &&
      contract.vehicle_is_transferred_another === false
    ) {
      return 7;
    } else if (
      contract.driver_is_transferred_another === false &&
      contract.vehicle_is_transferred_another === true
    ) {
      return 6;
    } else if (
      contract.driver_is_transferred_another === true &&
      contract.vehicle_is_transferred_another === true
    ) {
      return 8;
    }

    return contract.status;
  };

  onChangeDateLocal = (date) => {
    const currentTimes = moment().valueOf();
    const nowTimes = moment().endOf("day").valueOf();
    const { from_datetime, to_datetime } = this.props.contractData;

    const start = moment(date).startOf("month");
    const endtime = moment(date).endOf("month");

    let timeFromChoose = start;
    let timeToChoose = endtime;
    if (start.valueOf() < from_datetime) {
      timeFromChoose = moment(from_datetime);
    } else {
      timeFromChoose = start;
    }

    if (endtime.valueOf() > to_datetime) {
      timeToChoose = moment(to_datetime);
    } else {
      if (currentTimes > endtime.valueOf()) {
        timeToChoose = endtime;
      } else {
        timeToChoose = moment();
      }
    }
    this.setState({
      from: timeFromChoose,
      end: timeToChoose,
    });
    this.props.onChangeDate(timeFromChoose.valueOf(), timeToChoose.valueOf());
  };

  componentDidMount() {
    const { contractData } = this.props;

    apiJourney
      .fetchSuggestCustomer({ contract_id: contractData.id })
      .then((res) => {
        if (res.status === "success") {
          this.setState({ dataSuggest: res.data });
        }
      });
  }

  handleChange = (value) => {
    if (this.props.onChangeName) {
      this.props.onChangeName(value.join(","));
    }
    // console.log("value", value);
  };

  render() {
    const { contractData, laybelData } = this.props;
    const {
      working_time_from,
      working_time_to,
      working_time_weekend_holiday_from,
      working_time_weekend_holiday_to,
      driver,
      vehicle,
      branch,
      vehicle_working_area,
    } = this.props.contractDataDetail;
    const { from, end, name, dataSuggest } = this.state;
    const {
      code,
      customer,
      status,
      term,
      from_datetime,
      to_datetime,
      member_customer,
    } = contractData;

    const columnData1 = [
      {
        name: "Mã hợp đồng",
        value: code,
      },
      {
        name: "Khách hàng",
        value: customer ? customer.name : "",
      },
      {
        name: "Admin",
        value: member_customer ? member_customer.name : "",
      },
      {
        name: "Trạng thái",
        value: STATUS_DATA[this.getStatus(contractData)],
      },
      {
        name: "Kỳ hạn hợp đồng",
        value: `${term} tháng`,
      },
    ];
    const columnData2 = [
      {
        name: "Thời hạn hợp đồng",
        value: `${moment(from_datetime).format("DD/MM/YYYY")} - ${moment(
          to_datetime
        ).format("DD/MM/YYYY")}`,
      },
      {
        name: "Tài xế",
        value: driver ? driver.name : "",
      },
      {
        name: "Biển KS",
        value: vehicle ? vehicle.number_plate : "",
      },
      {
        name: "Thời gian làm việc ngày thường",
        value: `${
          working_time_from
            ? moment(working_time_from, "HH:mm:ss").format("HH:mm")
            : ""
        } - ${
          working_time_to
            ? moment(working_time_to, "HH:mm:ss").format("HH:mm")
            : "--:--"
        }`,
      },
      {
        name: "Thời gian làm việc ngày lễ/cuối tuần",
        value: `${
          working_time_weekend_holiday_from
            ? moment(working_time_weekend_holiday_from, "HH:mm:ss").format(
                "HH:mm"
              )
            : "--:--"
        } - ${
          working_time_weekend_holiday_to
            ? moment(working_time_weekend_holiday_to, "HH:mm:ss").format(
                "HH:mm"
              )
            : "--:--"
        }`,
      },
    ];

    const columnData3 = [
      {
        name: "Số ngày trong tháng",
        value: moment(from).endOf("month").format("DD"),
      },
      {
        name: "Số ngày làm việc theo HĐ",
        value: `${laybelData.contract_working_days} ngày`,
      },
      {
        name: "Số ngày thực tế làm việc",
        value: `${laybelData.real_working_days} ngày`,
      },
      {
        name: "Ngày đầu tiên phục vụ",
        value: moment(from_datetime).format("DD/MM/YYYY"),
      },
    ];

    return (
      <div className="driverless-short-info">
        <div className="left">
          <div className="range-date">
            <div className="date-container">
              <span style={{ marginRight: 7 }}>* Bắt đầu từ</span>
              <DatePicker
                value={from}
                // inputReadOnly
                clearIcon={false}
                onChange={(date) => this.onChangeDateLocal(date)}
                className="date-picker"
                disabledDate={(currentDate) => {
                  const currentTimes = currentDate.valueOf();
                  const nowTimes = moment().endOf("day").valueOf();
                  if (to_datetime > nowTimes) {
                    if (
                      currentTimes >= from_datetime &&
                      currentTimes < nowTimes
                    ) {
                      return false;
                    }
                    return true;
                  } else {
                    if (
                      currentTimes >= from_datetime &&
                      currentTimes <= to_datetime
                    ) {
                      return false;
                    }
                    return true;
                  }
                }}
                //dropdownClassName="date-picker-dropdown-top"
                getPopupContainer={(node) => {
                  if (node) {
                    return node.parentNode;
                  }
                  return document.body;
                }}
                format="DD/MM/YYYY"
              />
            </div>
            <div style={{ marginTop: 7 }} className="date-container">
              <span style={{ marginRight: 7 }}>* Đến</span>
              <DatePicker
                value={end}
                clearIcon={false}
                // inputReadOnly
                onChange={(date) => this.onChangeDateLocal(date)}
                disabledDate={(currentDate) => {
                  const currentTimes = currentDate.valueOf();
                  const nowTimes = moment().endOf("day").valueOf();
                  if (to_datetime > nowTimes) {
                    if (
                      currentTimes >= from_datetime &&
                      currentTimes < nowTimes
                    ) {
                      return false;
                    }
                    return true;
                  } else {
                    if (
                      currentTimes >= from_datetime &&
                      currentTimes <= to_datetime
                    ) {
                      return false;
                    }
                    return true;
                  }
                }}
                className="date-picker"
                //dropdownClassName="date-picker-dropdown-top"
                getPopupContainer={(node) => {
                  if (node) {
                    return node.parentNode;
                  }
                  return document.body;
                }}
                format="DD/MM/YYYY"
              />
            </div>

            <div style={{ marginTop: 7 }} className="date-container">
              <span style={{ marginRight: 7 }}>Người sử dụng</span>

              <Space direction="vertical" style={{ width: 200 }}>
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Người sử dụng"
                  onChange={this.handleChange}
                  maxTagCount="responsive"
                  optionFilterProp="label"
                  options={dataSuggest.map((item) => ({
                    label: item.name,
                    value: item.id,
                  }))}
                />
              </Space>
            </div>
          </div>
          <div className="text-info">
            <div className="circle" />
            Chi nhánh quản lý xe: {branch ? branch.code : null}
          </div>
          <div className="text-info">
            <div className="circle" />
            Khu vực xe chạy:{" "}
            {vehicle_working_area ? vehicle_working_area : null}
          </div>
        </div>
        <div className="left">
          {columnData1.map((value) => {
            return (
              <div key={value.name} className="text-info">
                <div className="circle" />
                {value.name}: {value.value}
              </div>
            );
          })}
        </div>
        <div className="left">
          {columnData2.map((value) => {
            return (
              <div key={value.name} className="text-info">
                <div className="circle" />
                {value.name}: {value.value}
              </div>
            );
          })}
        </div>
        <div style={{ marginRight: 0 }} className="left">
          {columnData3.map((value) => {
            return (
              <div key={value.name} className="text-info">
                <div className="circle" />
                {value.name}: {value.value}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
